export enum RoutePath {
  Dashboard = "/",
  Users = "/users",
  Login = "/login",
}

export const RouteLabel = {
  [RoutePath.Dashboard]: "Dashboard",
  [RoutePath.Users]: "Users",
} as const;
